// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    url: '',
    base_url: '',
    api_ws: 'EcorecServerAngular/push/',
    api_url: '/EcorecServerAngular/rest/main',
    old_api_url: '',
    api_dmd: '/EcorecServerAngular/rest/portail',
    api_url_ecoportail: '/EcoPortail/rest/portail',
    key: 'AIzaSyAxUo7NcwRdVXPfyHtkJSfKlpT3l-RSDUg',
    api_url_ecomobile: '/EcoCarto/rest/ecocarto',
    api_url_ecostat: '/Ecostat/rest/kerlog/NOTDEFINED/user/save/from/ecoportail',
    image_url: 'EcorecServerAngular/images/',
    LICENCEKEY_WACOM: 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI3YmM5Y2IxYWIxMGE0NmUxODI2N2E5MTJkYTA2ZTI3NiIsImV4cCI6MjE0NzQ4MzY0NywiaWF0IjoxNTYwOTUwMjcyLCJyaWdodHMiOlsiU0lHX1NES19DT1JFIiwiU0lHQ0FQVFhfQUNDRVNTIl0sImRldmljZXMiOlsiV0FDT01fQU5ZIl0sInR5cGUiOiJwcm9kIiwibGljX25hbWUiOiJTaWduYXR1cmUgU0RLIiwid2Fjb21faWQiOiI3YmM5Y2IxYWIxMGE0NmUxODI2N2E5MTJkYTA2ZTI3NiIsImxpY191aWQiOiJiODUyM2ViYi0xOGI3LTQ3OGEtYTlkZS04NDlmZTIyNmIwMDIiLCJhcHBzX3dpbmRvd3MiOltdLCJhcHBzX2lvcyI6W10sImFwcHNfYW5kcm9pZCI6W10sIm1hY2hpbmVfaWRzIjpbXX0.ONy3iYQ7lC6rQhou7rz4iJT_OJ20087gWz7GtCgYX3uNtKjmnEaNuP3QkjgxOK_vgOrTdwzD-nm-ysiTDs2GcPlOdUPErSp_bcX8kFBZVmGLyJtmeInAW6HuSp2-57ngoGFivTH_l1kkQ1KMvzDKHJbRglsPpd4nVHhx9WkvqczXyogldygvl0LRidyPOsS5H2GYmaPiyIp9In6meqeNQ1n9zkxSHo7B11mp_WXJXl0k1pek7py8XYCedCNW5qnLi4UCNlfTd6Mk9qz31arsiWsesPeR9PN121LBJtiPi023yQU8mgb9piw_a-ccciviJuNsEuRDN3sGnqONG3dMSA',
    /*urlEcoportailFile: '/EcoPortail',*/
    ip_ecoportail: '',
    versionCheckURL: 'version.json',
    apiToken: 'pk.eyJ1IjoicGluZWRlIiwiYSI6ImNpbGRnYWg5bjAwMGF2amtxbGVhNnFzNTkifQ.qesupg-hueHJhTlgIvazzw',
    only_ecorec: false,
    moduleEcoloc: false,
    moduleEcofact: false,
    moduleEcocrm: false,
    moduleEcobennes: false,
    moduleEcorh: false,
    moduleEcoportailOnly: true,
    moduleEcomobileOnly: false,
    moduleEcocarto: false,
    moduleEcodechet: false,
    moduleEcocontrat: false,
    moduleEcobac: false,
    moduleEcopol: false,
    moduleEcotri: false,
    moduleEcodec: false,
    moduleEcodd: false,
    moduleEcostock: false,
    moduleEcogar: false,
    isOpenId: false,
    moduleRDV: false,
    keyLicenceGoogleAPI: '',
    api_url_ecodechetCom: 'EcoPortail/rest/portail',
    image_url_ecodechetCom: 'EcoPortail/images/iconADR/',
    url_collectivite: 'EcodechetRDVCollectivite',
    keyGoogleMAP: 'AIzaSyB7bGoJTh-PD6sdlIVJPxPAFb2Zc2OAj2s',
    integrationKey: 'a2eb2482-8ff0-4dd7-9a76-a5e598ef35a7',
    routes: [
        { path: 'ecoportail', loadChildren: () => import('../app/ecoportail/ecoportail.module').then(m => m.EcoportailModule) },
        { path: 'cartographie', loadChildren: () => import('../app/ecomobile/ecomobile.module').then(m => m.EcomobileModule) },
    ]
};
